import type { CoauthorPresence } from "../hooks/useCoauthorPresence";

interface Props {
  peers: CoauthorPresence[];
  connected: boolean;
  compact?: boolean;
}

export default function CoauthorPresenceStrip({ peers, connected, compact }: Props) {
  if (!connected || peers.length === 0) return null;

  const max = compact ? 3 : 5;
  const visible = peers.slice(0, max);
  const overflow = peers.length - visible.length;
  const size = compact ? 22 : 26;
  // F3: collision awareness — surface who is actively typing right now.
  const editingPeers = peers.filter((p) => p.editing);
  const label =
    editingPeers.length === 1
      ? `${editingPeers[0]!.name} is editing now`
      : editingPeers.length > 1
        ? `${editingPeers.length} co-authors editing now`
        : peers.length === 1
          ? `${peers[0]!.name} is here`
          : `${peers.length} co-authors here`;

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: compact ? "2px 6px" : "4px 10px",
        background: "#f0e4ea",
        border: "1px solid #e2cbd4",
        borderRadius: 999,
      }}
      title={label}
    >
      <div style={{ display: "inline-flex" }}>
        {visible.map((p, i) => (
          <div
            key={p.userId}
            title={p.editing ? `${p.name} is editing now` : p.name}
            style={{
              position: "relative",
              width: size,
              height: size,
              borderRadius: "50%",
              background: p.colour,
              color: "#fff",
              fontSize: compact ? 10 : 11,
              fontWeight: 600,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #fff",
              marginLeft: i === 0 ? 0 : -8,
              letterSpacing: 0.3,
            }}
          >
            {p.initials}
            {p.editing && (
              <span
                style={{
                  position: "absolute",
                  bottom: -1,
                  right: -1,
                  width: compact ? 8 : 9,
                  height: compact ? 8 : 9,
                  borderRadius: "50%",
                  background: "#2d8a56",
                  border: "1.5px solid #fff",
                }}
              />
            )}
          </div>
        ))}
        {overflow > 0 && (
          <div
            style={{
              width: size,
              height: size,
              borderRadius: "50%",
              background: "#1C2951",
              color: "#fff",
              fontSize: compact ? 10 : 11,
              fontWeight: 600,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #fff",
              marginLeft: -8,
            }}
          >
            +{overflow}
          </div>
        )}
      </div>
      {!compact && (
        <span style={{ fontSize: 12, color: editingPeers.length > 0 ? "#1C2951" : "#2c2c2c", fontWeight: editingPeers.length > 0 ? 600 : 400, whiteSpace: "nowrap" }}>
          {label}
        </span>
      )}
    </div>
  );
}
